import { apiClient } from '../apiClient';
import { GuardiansQueryParams, GuardiansResponse } from '../../types/guardian';

class GuardiansService {
    async getGuardians(params: GuardiansQueryParams): Promise<GuardiansResponse> {
        const response = await apiClient.get('/api/v1/admin/guardians', { params });
        return response.data;
    }
}

export const guardiansService = new GuardiansService(); 